import { render, staticRenderFns } from "./CampoSeletorCliente.vue?vue&type=template&id=baa5001e&"
import script from "./CampoSeletorCliente.vue?vue&type=script&lang=js&"
export * from "./CampoSeletorCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports